import { MapDatasource } from '..';

export class MapLayers extends MapDatasource {
}